<template>
  <table class="table table-borderless table-align table-h51">
    <thead>
      <tr>
        <th>ID</th>
        <th>Conta</th>
        <th>AIT</th>
        <th>Placa</th>
        <th>Status</th>
        <th>Status da análise</th>
        <th>Órgão consultado</th>
        <th>Criado em</th>
        <th>Atualizado em</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="ticket in ticketHistories" :key="ticket.id">
        <td>{{ ticket.id }}</td>
        <td>{{ getAccountName(ticket) }}</td>
        <td>{{ ticket.ait }}</td>
        <td>{{ ticket.plate }}</td>
        <td>{{ ticket.status | statusTicket }}</td>
        <td>{{ ticket.analysisStatus | analysisStatus }}</td>
        <td>{{ ticket.consultedAuthority }}</td>
        <td>{{ ticket.createdAt | datetime }}</td>
        <td>{{ ticket.updatedAt | datetime }}</td>
        <td>

          <div class="btn-group">
            <router-link
              v-if="linkRequest"
              :to="`/admin/maestro/requests/${ticket.requestId}`"
              class="btn btn-outline"
            >
              Requisição
            </router-link>

            <router-link
              v-if="linkTicket && ticket.ticketId"
              :to="`/admin/maestro/tickets/${ticket.ticketId}`"
              class="btn btn-outline"
            >
              Multa
            </router-link>

            <router-link
              :to="`/admin/maestro/ticket_histories/${ticket.id}`"
              class="btn btn-outline"
            >
              Ver
            </router-link>
          </div>
        </td>
      </tr>
      </tbody>
  </table>
</template>

<script>
import { Translate } from '@/services/Translate'

export default {
  filters: {
    statusTicket(status) {
      return Translate(`ticket.${status}`)
    },
    analysisStatus(status) {
      return {
        not_analyzed: 'Não analisado',
        analyzing: 'Em análise',
        analyzed: 'Analisado',
      }[status]
    }
  },
  inject: ['getAccountName'],
  name: 'Table',
  props: {
    ticketHistories: { required: true, type: Array },
    linkRequest: { default: false, type: Boolean },
    linkTicket: { default: false, type: Boolean },
  }
}

</script>

<style scoped>

</style>